// eslint-disable-next-line
export const flickrAPIkey = '77f6b0a04a950befdfc4cd2cc36994f4';
export const photoSetID = '72157682928162795';
export const userID = '134604478@N02';



// WEBPACK FOOTER //
// ./src/config.js